import { Injectable, signal } from "@angular/core";

@Injectable({ providedIn: "root" })
export class TitleService {
    goBack = signal<string[]>(undefined);
    title = "Markings as a Service";
}
